/* eslint-disable no-console */
/* eslint-disable max-len */
/* eslint-disable multiline-ternary */
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CloseIcon from '@mui/icons-material/Close';
import {
	Box,
	Dialog, DialogContent,
	DialogTitle,
	IconButton, Stack,
	Tooltip
} from '@mui/material';
import React from 'react';
import VideoPreview from './VideoPreview';
import DocViewer, { DocViewerRenderers } from 'react-doc-viewer';

type PreviewModalProps = {
    // open: boolean;
    // handleClose: () => void;
    // mediaList: Array<{ id: number; img: string; name: string }>;
    mediaList: Array<any>;
    currentIndex: number;
    setCurrentIndex: (index: number) => void;
	setIsVideoPlaying: React.Dispatch<React.SetStateAction<boolean>>;
	openVideo:any
};

const MediaPreview: React.FC<PreviewModalProps> = ({
	mediaList,
	currentIndex,
	setCurrentIndex,
	setIsVideoPlaying,
	openVideo
}) =>
{
	// const { img, name } = mediaList[currentIndex];
	const currentMedia = mediaList[currentIndex];

	// const isVideo = /\.(mp4|webm|ogg)$/i.test(currentMedia?.name);
	const isVideo = currentMedia?.type.match('video') || currentMedia?.type === 'youtube';
	const isImage = currentMedia?.type.match('image');
	const isDocument = currentMedia?.type.match('application');

	return (
		<div className='flexRow alignCntr justifyCntr fullHeight positionRelative'>
			<div className='flexRow newsSlider alignCntr justifyCntr'>
				<div className={`flexRow ${isVideo ? 'sliderCntnrvideo' : 'sliderCntnr'} `}>
					<Box sx={{ width: '100%' }}>
						<IconButton
							onClick={() => setCurrentIndex(currentIndex - 1)}
							sx={{ position: 'absolute', left: 10, top: 'var(--percent50)', transform: 'translateY(-50%)', color: 'var(--whiteColor)', zIndex: '999', background: 'rgba(0, 0, 0, 0.7)' }}
							disabled={currentIndex === 0}
						>
							<ArrowBackIosNewIcon />
						</IconButton>

						{isVideo &&
						<VideoPreview openVideo={openVideo} setIsVideoPlaying={setIsVideoPlaying} key={currentIndex}
							currentMedia={currentMedia}
						/>}
						{isImage &&
						<img
							src={currentMedia?.url.concat('?new=t')}
							alt={'feed image'}
							style={{
								width        : 'var(--percent100)',
								height       : 'var(--percent100)',
								objectFit    : 'contain',
								borderRadius : 'var(--pixel8)'
							// background   : 'rgba(0, 0, 0, 0.5)'
							}}
						/>
						}
						{isDocument &&
						<DocViewer
							documents={[ { uri: currentMedia?.url, fileType: currentMedia?.key?.split('.').pop() } ]}
							pluginRenderers={DocViewerRenderers}
							style={{ width: 'var(--percent100)', height: 'var(--percent100)' }}
						/>
						}
						<IconButton
							onClick={() => setCurrentIndex(currentIndex + 1)}
							sx={{ position: 'absolute', right: 10, top: 'var(--percent50)', transform: 'translateY(-50%)', color: 'var(--whiteColor)', zIndex: '999', background: 'rgba(0, 0, 0, 0.7)' }}
							disabled={currentIndex === mediaList.length - 1}
						>
							<ArrowForwardIosIcon />
						</IconButton>
					</Box>
				</div>
			</div>
		</div>
	);
};

export default MediaPreview;
